<template>
  <a-modal
    title="编辑"
    width="500px"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-card :body-style="{padding: '2px 2px'}" :bordered="false">

      <a-form  :form="form">

        <a-form-item
          label="角色名称"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入角色名称"
            v-decorator="[ 'name']"
            :theDefaultValue="name" />
        </a-form-item>

        <a-form-item
          label="角色权限"
          :labelCol="{lg: {span: 6}, sm: {span: 7}}"
          :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
          <a-input
            placeholder="请输入角色权限"
            v-decorator="[ 'des']"
            :theDefaultValue="des" />
        </a-form-item>

      </a-form>
    </a-card>
  </a-modal>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import SelectHospital from '@/components/selector/SelectHospital'
import { editData, editTaskData } from '@/api/data'
import { updateUserInfo } from '@/api/adminuser'
import { DEFAULT_IMAGE } from '@/utils/const'
import { fetchFileUrl } from '@/api/file'
import { getGenderText, getHospitalText, getUserRole } from '@/utils/const'
import { updateRole } from '../../../api/adminrole';

export default {
  name: 'EditRoleModal',
  components: {
    SelectHospital
  },
  data () {
    return {
    //   image: DEFAULT_IMAGE,
      visible: false,
      id: '',
      name: '',
      des: '',
      opened: false,
      form: this.$form.createForm(this),
      spinning: false

    }
  },

  methods: {
    edit (record) {
      this.visible = false
      this.opened = false
      const _this = this
      //   this.image = DEFAULT_IMAGE
      this.$nextTick(() => {
        _this.spinning = true
        // fetchFileUrl({ data_id: record.data_id }).then(res => {
        //   _this.image = res.data
        // })
        _this.visible = true
        _this.opened = true
        _this.id = record.origin_data.id
        _this.name = record.name
        _this.des = record.origin_data.des
        this.$nextTick(() => {
          _this.form.setFieldsValue({
            uid: record.origin_data.id,
            name: record.origin_data.name,
            des: record.des
          })
        })
      })
    },
    noSpinning () {
      this.spinning = false
    },
    handleCancel () {
      this.visible = false
      this.opened = false
    },
    // handler
    handleOk () {
      //
      const _this = this
      this.form.validateFields((err, values) => {
        //
        if (!err) {
          const params = {
            id: _this.id,
            name: values.name,
            des: values.des,
            // source_id: this.$refs.hospital.value || this.$refs.hospital.theDefaultValue,
            // data_des: values.data_des,
            // case_gender: values.case_gender,
            // case_age: values.case_age
          }
          var request = updateRole
          //   if (_this.$store.getters.isProjectCreater) request = editTaskData
          request(params).then(res => {
            //   console.log("res.code")
            //   console.log(res.code)
            //   console.log("res.log")
            //   console.log("res.msg")
            //   console.log(res.msg)
            //   console.log("res.msg")
           if(res.code === 200) {
            _this.$message.success('修改成功')
            _this.$emit('dataChanged')
            _this.visible = false
            _this.opened = false
            }
            else{
             _this.$message.error(res.msg)
             _this.visible = false
             _this.opened = false 
          }  
          }).catch((err) => {
            _this.$message.error('修改失败')
          })
        }
      })
    }
  }
}
</script>
